import {createSinglePathSVG} from '#/components/icons/TEMPLATE'

/** Lucide candy, used only for Halloween. See licenses/LUCIDE-ISC.txt. */
export const CandyIcon = createSinglePathSVG({
  path: 'M10 7v10.9 M14 6.1V17 M16 7V3a1 1 0 0 1 1.707-.707 2.5 2.5 0 0 0 2.152.717 1 1 0 0 1 1.131 1.131 2.5 2.5 0 0 0 .717 2.152A1 1 0 0 1 21 8h-4 M16.536 7.465a5 5 0 0 0-7.072 0l-2 2a5 5 0 0 0 0 7.07 5 5 0 0 0 7.072 0l2-2a5 5 0 0 0 0-7.07 M8 17v4a1 1 0 0 1-1.707.707 2.5 2.5 0 0 0-2.152-.717 1 1 0 0 1-1.131-1.131 2.5 2.5 0 0 0-.717-2.152A1 1 0 0 1 3 16h4',
  strokeWidth: 1.5,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
})

/** Keep the supplied outline in both states; color indicates a given candy. */
export const candyIcons = {outline: CandyIcon, filled: CandyIcon}
